import { API } from "./api";
export const register = (newUser) => API.post("/users/register", newUser);

export const login = async (email, password) => {
  try {
    const response = await API.post("/users/login", { email, password });
    const token = response?.data?.token;
    if (token) {
      localStorage.setItem("token", token);
    }

    return response;
  } catch (error) {
    throw error;
  }
};
export const requestResetPassword = async (email) => {
  try {
    await API.post("/users/request-reset-password", { email });
    return "Password reset email sent successfully.";
  } catch (error) {
    throw error;
  }
};
export const resetPassword = async (token, newPassword) => {
  try {
    await API.post(`/users/reset-password/${token}`, { newPassword });
    return "Password updated successfully.";
  } catch (error) {
    throw error;
  }
};
export const  verifyEmail = async (token) => {
  try {
    const response = await API.get(`/users/verifyEmail/${token}`); // Send a POST request with the token
    return response;
  } catch (error) {
    throw error;
  }
};
export const getCurrentUser = () => API.get("users/me");
export const updateProfile = (formData) => API.put("/users/me", formData);
